import React from 'react'
import './index.less'
export default class extends React.Component {
  state = {
    show:false
  }

  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }
  hideRule = async (status) => {
    document.getElementById(`closelistdiv`).setAttribute("class", "closelistdivhide")
  
  }
  render() {
    let {roomList,deltItem,lang } = this.props
    return (
       <div className="reportTitle" id="closelistdiv">
        <div className="title" >
          {lang.adminRoom}
        </div>
        <div className="content" >
            <RoomList roomList={roomList} delectItem = {deltItem} roomId = {lang.roomId}></RoomList>
        </div>
      </div>
    )
  }
}

class RoomList extends React.Component {
    
    render() {
        let {roomList, delectItem,roomId} = this.props
        return (
          roomList.map((item,index)=>{
            return (<div className="listItem" key={index}>
            <div className="itemInfo">
                {roomId}:{item.GroupName}
            </div>
            <div className="itemBtn" onClick={()=>delectItem(item.gid)}>
                quit
            </div>
          </div>)
          })
        )
      }
}


// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/adminRoomList/index.js